import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type FontId = Brand<string, 'fontId'>;

export const FONT_SCHEMA: z.ZodType<IFont> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as FontId)
    .optional(),
  filename: z.string(),
  name: z.string(),
});

export const FONTS_SCHEMA: z.ZodType<IFont[]> = z.array(FONT_SCHEMA);

export interface IFont {
  id?: FontId;
  filename: string;
  name: string;
}
